import getOption from './getOption';
import { Option } from '../../types/stepFlow.type';

const getOptions = (values: string[], allOptions?: Option[]): Option[] => {
  return values.map((value) => getOption(value, undefined, allOptions));
};

export default getOptions;
